"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var SvgNavigationPointer02 = function (props) { return ((0, jsx_runtime_1.jsx)("svg", __assign({ width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props, { children: (0, jsx_runtime_1.jsx)("path", { d: "M12.666 1.903a1.5 1.5 0 0 0-1.34 0c-.374.186-.567.514-.658.681-.1.182-.203.416-.306.651L3.05 19.905c-.115.262-.227.516-.298.727-.062.182-.187.575-.053.998a1.5 1.5 0 0 0 .98.979c.423.133.816.007.998-.055.21-.071.464-.183.727-.298l6.59-2.9 6.592 2.9c.262.115.516.227.727.299.181.061.575.187.998.053a1.5 1.5 0 0 0 .98-.978c.133-.423.008-.816-.054-.998-.07-.211-.182-.465-.297-.727l-7.312-16.67a8.688 8.688 0 0 0-.305-.65c-.092-.168-.285-.496-.658-.682Z", fill: "currentColor" }) }))); };
exports.default = SvgNavigationPointer02;
